<template lang="pug">
  .recommended-gloss.clearfix
    .gloss-product-info.xs-12
      img.gloss-image.pull-left(:src="glossImageObj.url" :alt="glossImageObj.alt_text")
      .gloss-info.pull-left
        span.gloss-name.upper.color-slate.xs-f-xsmall.max-at-tweak {{ product.name }}
        span.gloss-price.bold.xs-f-small.lg-f-medium.max-at-tweak {{ product.price | currency }}

      .gloss-ctas.xs-12
        button.btn-reset.pull-left.color-purple.xs-f-small.max-at-tweak(@click="goToSeeAllShades") See all shades
        button.btn-reset.pull-right.color-purple.xs-f-small.max-at-tweak(@click="goToLearnMore") Learn more
</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex';

  export default {
    name: "RecommendedGloss",

    props: {
      product: {
        type: Object,
        required: true
      }
    }, 

    inject: ['getObjProperty'],

    computed: {
      glossImageObj() {
        return this.getObjProperty(this.product, "imagery") || {};
      }
    },

    methods: {
      goToSeeAllShades() {
        window.location = "shop/gloss";
      },
      goToLearnMore() {
        window.location = "shopping/gloss";
      }
    }
  }
</script>

<style scoped lang="stylus">
  .recommended-gloss
    padding 0 1em

    .gloss-product-info
      padding 1.5em 30%

      .gloss-image
        width 7em
        margin-right 1em
        display inline-block
        vertical-align top

      .gloss-info
        text-align left
        display inline-block
        vertical-align top

        span
          display block
          text-align left
      .gloss-ctas 
        padding-top 1.5em

      @media mq-mobile
        padding 1.5em 5%
      @media mq-tablet
        padding 1.5em 20%
</style>